<template>
  <div>
    <div class="bd-header bd-header_maxim">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/maxim/img/logo.svg" alt="">
      </div>
    </div>
    <div class="bd-feed bd-feed_maxim">
      <div class="bd-maxim">
        <div class="bd-maxim__menu">
          <div class="bd-maxim__menu-wrap">
            <div class="bd-maxim__menu-el">Девушки</div>
            <div class="bd-maxim__menu-el">Спорт</div>
            <div class="bd-maxim__menu-el">Чтиво</div>
            <div class="bd-maxim__menu-el">Юмор</div>
            <div class="bd-maxim__menu-el">Навыки</div>
            <div class="bd-maxim__menu-el">Видео</div>
            <div class="bd-maxim__menu-el bd-maxim__menu-el_active">В курсе</div>
            <div class="bd-maxim__menu-el">Стиль</div>
            <div class="bd-maxim__menu-el">Киберспорт</div>
            <div class="bd-maxim__menu-el">Конкурсы</div>
          </div>
        </div>
        <div class="bd-maxim__title">
          Ученые сделали первый успешный шаг к созданию искусственных нервов
        </div>
        <div class="bd-maxim__p">Стальные нервы бывают только у сказочных
          персонажей вроде Дзержинского и Терминатора. Зато
          вполне реальные люди скоро смогут получить нервы синтетические.
          И не для того, чтобы стать менее чувствительными, а
          ровно наоборот.</div>
        <img src="/pages/maxim/img/baner.png" alt="" class="bd-maxim__img">
        <div class="bd-maxim__p">Любого из нас можно почти полностью заменить.
          Не в смысле найти замену как личности (понятно,
          все мы неповторимы,&nbsp;других таких не сыскать), а в
          смысле замены рук, ног, ушей и прочих частей тела
          искусственными. Считая даже всеми любимый орган, который
          давно уже продается как самостоятельный аксессуар в
          специализированных магазинах.</div>

        <buzzCode @ready="ready" :id="id"></buzzCode>

        <div class="bd-maxim__p">Но с ненатуральными деталями, пришитыми
          взамен утраченных, всегда проблема: на них можно
          ходить, ими можно хватать, но ими нельзя ощущать. Человек на
          протезах, в экзоскелете, с искусственными кожей и членом
          может функционировать, однако будет чувствовать
          себя получеловеком-полумопедом.</div>
        <div class="bd-maxim__p">По этой причине ученые активно пытаются
            придумать искусственные нервы, которые можно было бы
          приаттачить к натуральной нервной системе. Но до сих пор речь
          шла о центробежных нервах, тех, что передают команду от
          мозга частям тела, — чтобы нога двигалась, а нос шмыгал.
          И вот наконец ученым из Стэнфорда и Сеульского университета
          удалась копия центро­стремительного нерва, ведущего
          сигнал обратно — от тела к мозгу.</div>
        <div class="bd-maxim__p"> Они взяли за образец природный механизм,
          который состоит из рецепторов, реагирующих на
          касание, а также проводящих нервов и синапса — узла,
          отправляющего сигнал в мозг.</div>
        <div class="bd-maxim__p">Роль рецепторов сыграли два электрода:
            плоский золотой и расположенный под ним углеродный с
          поверхностью из крошечных пирамидок. Чем больше давление,
          тем больше контакт между электродами. Сигнал от них
          преобразуется в импульсы, в которых закодирована сила давления.
          Те поступают в транзистор, а он формирует сигнал для
          мозга: до рецептора дотронулись.</div>
        <div class="bd-maxim__p">Изобретение уже распознает рельефные
            символы алфавита для слепых, а когда его присоединили к
          лапкам таракана и сымитировали нервный сигнал, насекомое
          стало отдергивать их от несуществующей помехи. Есть надежда,
          что вскоре появятся протезы и даже искусственная
          кожа с функцией осязания.</div>
        <div class="bd-maxim__more-wrap">
          <div class="bd-maxim__more">
            А если подпрыгнуть в падающем лифте — поможет? Отвечают физики
          </div>
          <div class="bd-maxim__more">
            Ученые высчитали, реально ли построить Стену из «Игры престолов» в нашем мире
          </div>
          <div class="bd-maxim__more">
            Как метать нож: 4 простых секрета, заставляющие лезвие вонзиться в цель
          </div>
        </div>
        <div class="bd-maxim__tags">
          <div class="bd-maxim__tags-el">наука</div>
          <div class="bd-maxim__tags-el">здоровье</div>
          <div class="bd-maxim__tags-el">роботы</div>
          <div class="bd-maxim__tags-el">прогресс</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'maxim',
  data() {
    return {
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    &_maxim
      background-color white
      & ^[1]__menu
        fill #ba0009
      .bd-ht__img
        width 50%
        height auto
        margin auto
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-maxim
    font-family sans-serif
    text-align left
    &__img
      display block
      width 100%
      height auto
      padding 5px 0 25px 0

    &__menu
      position relative
      height 35px
      font-family 'Roboto Condensed', sans-serif
      font-size 0
      overflow hidden
      &:before
      &:after
        box-shadow -2px 0 16px #fff, inset -16px 0 16px #fff
        content ''
        position absolute
        top 0
        bottom 0
        right 0
        width 16px

      &:before
        box-shadow 0 0 16px #fff, inset 16px 0 16px #fff
        left 0

      &-wrap
        padding 0 20px 20px
        white-space nowrap
        overflow-x scroll

      &-el
        display inline-block
        padding 10px 7.5px
        fontSize(15, 15)
        font-weight bold
        text-transform uppercase
        color black

    &__title
      margin 10px 25px 20px
      padding 0 0 10px
      border-bottom 1px solid rgba(black, .15)
      font-family serif
      fontSize(28, 30)
      color black

    &__p
      padding 0 25px 30px
      font-family "PT Sans", sans-serif
      fontSize(15, 19)

    &__more
      padding-bottom 15px
      font-family serif
      fontSize(18, 24)
      color black

      &-wrap
        padding 0 25px
        &:before
          content ""
          display block
          width 21%
          height 1px
          margin-bottom 10px
          background-color #b2b2b2
    &__tags
      padding 0 25px 20px
      font-size 0

      &-el
        display inline-block
        margin 0 10px 10px 0
        padding 5px 10px
        background-color rgba(42,123,183,.1)
        fontSize(13, 13)
        color #2a7bb7

</style>
